import UIkit from './UIkit';

const initScrollspy = () => {
  const scrollspy = UIkit.scrollspy('.uk-scrollspy', {});
};

export default initScrollspy;
